module.exports = __webpack_public_path__ + "img/github-icon.fe081a6e.svg";